var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attachments-list"},_vm._l((_vm.attachments),function(attachment){return _c('div',{key:attachment.id},[_c('Attachment',{attrs:{"item":attachment}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }